import React from "react";
import Home from "./Home2/Home";

const Stays = () => {
  return (
    <div>
      <Home />
    </div>
  );
};

export default Stays;
